module.exports = __webpack_public_path__ + "media/images/man_working_on_deadline-ced169eb54677bfa355c953dce4e1e25.svg";